import { AlertTriangle, Clock, Wrench, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";

function difficultyColor(d) {
  const k = (d || "").toLowerCase();
  if (k === "easy") return "text-[#6CC24A]";
  if (k === "medium") return "text-[#EAB308]";
  return "text-[#F87171]";
}

export default function TrustLeaks({ leaks = [], onFix, narration }) {
  const recLookup = new Map(
    (narration?.recommendations || []).map((r) => [r.finding_id, r]),
  );
  return (
    <div className="pp-surface" data-testid="trust-leaks-panel">
      <div className="px-6 py-5 border-b border-[#333C47] flex items-baseline justify-between">
        <div>
          <div className="pp-label mb-1">Biggest Trust Leaks</div>
          <div className="font-display text-xl text-white">
            The three issues costing you the most trust right now.
          </div>
        </div>
        <div className="pp-badge-danger">
          <AlertTriangle className="h-3 w-3" /> Immediate impact
        </div>
      </div>
      <div className="divide-y divide-[#333C47]">
        {leaks.length === 0 && (
          <div className="p-6 text-center text-sm text-[#C7CBD1]">
            No leaks detected. You're already ahead of most of your competitors.
          </div>
        )}
        {leaks.map((leak, i) => {
          const rec = recLookup.get(leak.id);
          const headline = rec?.headline || leak.title;
          const why = rec?.why_it_matters || leak.why;
          const fix = rec?.how_to_fix || leak.fix;
          return (
            <motion.div
              key={leak.id}
              initial={{ opacity: 0, x: -12 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.1 + i * 0.08 }}
              className="p-6"
              data-testid={`trust-leak-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className="metric text-[#EF4444] font-bold text-sm w-14 pt-0.5">
                  LEAK 0{i + 1}
                </div>
                <div className="flex-1">
                  <div className="text-white font-display font-semibold text-lg leading-snug">
                    {headline}
                  </div>
                  {why && (
                    <div className="mt-2 text-sm text-[#C7CBD1] leading-relaxed">
                      {why}
                    </div>
                  )}
                  {fix && (
                    <div className="mt-2 text-sm text-white leading-relaxed">
                      <span className="text-[#6CC24A] font-medium">Fix: </span>
                      {fix}
                    </div>
                  )}
                  <div className="mt-4 flex flex-wrap items-center gap-2">
                    {leak.impact != null && (
                      <span className="pp-badge-danger">
                        −{leak.impact} trust
                      </span>
                    )}
                    <span className="pp-badge-neutral">
                      <Clock className="h-3 w-3" /> {leak.time}
                    </span>
                    <span className={`pp-badge-neutral ${difficultyColor(leak.difficulty)}`}>
                      <Wrench className="h-3 w-3" /> {leak.difficulty}
                    </span>
                    <button
                      onClick={() => onFix?.(leak)}
                      data-testid={`fix-leak-${i}`}
                      className="ml-auto pp-btn-primary text-sm flex items-center gap-2"
                    >
                      Fix now <ArrowRight className="h-3.5 w-3.5" />
                    </button>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
